export default __webpack_public_path__ + "static/media/Bestand.de48e1bf.png";